import { useCurrentUserProfile } from '@/entities/user/model/use-current-user-profile'
import { useWorkspaceEntitlementsQuery } from '@/graphql/queries/workspaceEntitlementsQuery.gql.generated'

const ENTITLEMENT_POLL_INTERVAL_MS = 30_000

export function useWorkspaceEntitlements() {
  const { currentUser } = useCurrentUserProfile()
  const workspaceId = currentUser?.workspaceId
  const query = useWorkspaceEntitlementsQuery({
    skip: !workspaceId,
    variables: { workspaceId: workspaceId ?? '' },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    context: { globalLoader: false },
    pollInterval: workspaceId ? ENTITLEMENT_POLL_INTERVAL_MS : 0,
  })
  const workspaceEntitlements = query.data?.workspaceEntitlements

  return {
    ...query,
    currentUser,
    entitlements:
      workspaceEntitlements?.workspaceId === workspaceId
        ? workspaceEntitlements
        : undefined,
    workspaceId,
  }
}
